import React from 'react'
import { Button, Card, ListItem, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

export default function ListComponent ({ center }) {
  const { centerId, centerName, address } = center
  return (
    <Card key={center.centerId} sx={{ margin: '10px auto', display: 'flex', flexDirection: 'column', padding: '5px 15px' }}>
      <ListItem disablePadding>
        <Typography size='sm' gutterBottom variant='h6' component='div'>
          {centerName || ''}
        </Typography>
      </ListItem>
      <ListItem disablePadding>
        <Typography size='sm' gutterBottom component='div'>
          {address?.address1} {address?.address2} {address?.city} {address?.pin}
        </Typography>
      </ListItem>
      <ListItem>
        <Link to={'/center/' + centerId}>
          <Button variant='contained'>View</Button>
        </Link>
        <Link to={'/center/' + centerId + '/edit'}>
          <Button>Edit</Button>
        </Link>
      </ListItem>
    </Card>
  )
}
